module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-company-manage"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "780px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "100px",
      "label-position": "left",
      "rules": _vm.formRules,
      "validate-on-rule-change": false
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "企业名称:",
      "prop": "name"
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入",
      "clearable": "",
      "fetch-suggestions": _vm.querySearch,
      "trigger-on-focus": false
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地区:",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.showname),
      callback: function($$v) {
        _vm.$set(_vm.form, "showname", $$v)
      },
      expression: "form.showname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业图标:"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "size": "small",
      "auto-upload": false,
      "on-change": _vm.imgPreview,
      "action": _vm.upload.postURL,
      "show-file-list": false
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon",
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "line-height": "100px"
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业管理员:"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择企业管理员"
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  }, _vm._l((_vm.companyManages), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "硬件绑定:",
      "required": ""
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#F66B3D",
      "active-value": 1,
      "inactive-value": 0,
      "inactive-color": "#F6F6F6"
    },
    model: {
      value: (_vm.isbinding),
      callback: function($$v) {
        _vm.isbinding = $$v
      },
      expression: "isbinding"
    }
  }), _c('span', {
    staticStyle: {
      "padding-left": "10px",
      "color": "#666666"
    }
  }, [_vm._v("是否启用硬件绑定")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户地址:",
      "required": "",
      "prop": "address"
    }
  }, [_c('GisCommon', {
    ref: "GisCommon",
    attrs: {
      "selected": _vm.selected,
      "address": _vm.form.address,
      "lonLat": this.position_.toString() || ''
    },
    on: {
      "update:address": function($event) {
        return _vm.$set(_vm.form, "address", $event)
      },
      "backPram": _vm.backPram
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "大区代号:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.loginType != '1'
    },
    model: {
      value: (_vm.form.regionCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "regionCode", $$v)
      },
      expression: "form.regionCode"
    }
  }, _vm._l((_vm.regionCodeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资质等级:",
      "prop": "grade"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }, _vm._l((_vm.gradeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业性质:",
      "prop": "natrue"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.natrue),
      callback: function($$v) {
        _vm.$set(_vm.form, "natrue", $$v)
      },
      expression: "form.natrue"
    }
  }, _vm._l((_vm.natureList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户规模:",
      "prop": "userScale"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.userScale),
      callback: function($$v) {
        _vm.$set(_vm.form, "userScale", $$v)
      },
      expression: "form.userScale"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业联系人:",
      "prop": "linker"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.linker),
      callback: function($$v) {
        _vm.linker = $$v
      },
      expression: "linker"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系方式:",
      "prop": "linkerPhone"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.linkerPhone),
      callback: function($$v) {
        _vm.linkerPhone = $$v
      },
      expression: "linkerPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户经理:"
    }
  }, [_c('SelectCommon', {
    attrs: {
      "placeholder": "客户经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/manageList",
      "disabled": _vm.loginType !== '1',
      "keys": {
        label: 'name',
        value: 'id'
      },
      "defaultVal": _vm.managerAdminuser
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户成功经理:"
    }
  }, [_c('SelectCommon', {
    staticClass: "kuang",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择客户成功经理",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 3
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "disabled": _vm.loginType !== '1',
      "defaultVal": _vm.successfulManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商:"
    }
  }, [_c('SelectCommon', {
    staticClass: "kuang",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择经销商",
      "clearable": true,
      "apiPath": "/tbAdminuser/list",
      "params": {
        type: 4
      },
      "keys": {
        label: 'name',
        value: 'id'
      },
      "disabled": _vm.loginType !== '1',
      "defaultVal": _vm.agencyManager
    },
    on: {
      "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
    }
  })], 1)], 1), _vm._v(" "), (_vm.editLevel) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "ratingClass",
    attrs: {
      "label": "客户分级:",
      "prop": "level"
    }
  }, [_c('el-rate', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "max": 3
    },
    model: {
      value: (_vm.form.level),
      callback: function($$v) {
        _vm.$set(_vm.form, "level", $$v)
      },
      expression: "form.level"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.note),
      callback: function($$v) {
        _vm.note = $$v
      },
      expression: "note"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "background": "#f66b3d",
      "color": "#fff",
      "width": "140px"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("保存设置")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-587e6e83"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/CompamySetting.vue
// module id = 1800
// module chunks = 9